import { __decorate } from "tslib";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { InstructorTableRowType } from "@/enums/InstructorTableRowType";
import InstructorTableKidSchoolCell from "@/classes/InstructorTableKidSchoolCell";
import InstructorsTableBase from "@/classes/InstructorsTableBase";
import { InstructorTableCellType } from "@/enums/InstructorTableCellType";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { NotificationTypes } from "@/enums/NotificationTypes";
import store from "@/store";
import Snackbar from "@/components/Snackbar.vue";
import { isDesktop } from "@/utils/isDesktop";
import { collectPayment, printReceipt } from "@/utils/payments";
let InstructorsTableKidSchoolCell = class InstructorsTableKidSchoolCell extends InstructorsTableBase {
    //<editor-fold desc="Props">
    cellData;
    dataSource;
    //</editor-fold>
    dialog = false;
    loading = false;
    togglingPremium = false;
    togglingLeader = false;
    payingKidId = '';
    printingReceiptId = '';
    //<editor-fold desc="Methods">
    async payKid(kid, method) {
        if (this.payingKidId)
            return;
        this.payingKidId = kid.kidId;
        try {
            const result = await collectPayment('payKidSchoolKid', {
                kidSchoolId: this.cellData.id,
                kidId: kid.kidId,
                date: this.dataSource.date.format('YYYY-MM-DD'),
            }, method);
            if (result) {
                await this.$store.dispatch('kidSchool/markKidPaid', {
                    id: this.cellData.id,
                    kidId: kid.kidId,
                    receiptId: result.receiptId,
                });
                Snackbar.success(`Doklad ${result.number} vystaven.`);
                if (result.warning) {
                    Snackbar.info(result.warning);
                }
            }
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e instanceof Error ? e.message : 'Platbu se nepodařilo zpracovat');
        }
        finally {
            this.payingKidId = '';
        }
    }
    async printKidReceipt(kid) {
        if (this.printingReceiptId || !kid.receiptId)
            return;
        this.printingReceiptId = kid.receiptId;
        try {
            await printReceipt(kid.receiptId);
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e instanceof Error ? e.message : 'Doklad se nepodařilo vytisknout');
        }
        finally {
            this.printingReceiptId = '';
        }
    }
    async togglePremium() {
        this.togglingPremium = true;
        if (!this.cellData.isPremium) {
            if (!await ConfirmDialog.open('Potvrzení', 'Opravdu chcete lekci označit jako prémiovou?')) {
                this.togglingPremium = false;
                return;
            }
        }
        this.cellData.isPremium = !this.cellData.isPremium;
        try {
            const kidSchool = await this.$store.dispatch('kidSchool/getById', this.cellData.id);
            await this.$store.dispatch('kidSchool/update', {
                ...kidSchool,
                isPremium: this.cellData.isPremium,
            });
            await this.updateDataSource();
        }
        catch (e) {
            console.error(e);
            Snackbar.error('Nepodařilo se změnit prémiovou lekci!');
        }
        finally {
            this.togglingPremium = false;
        }
    }
    async changeLeader(instructorId) {
        this.togglingLeader = true;
        this.cellData.leaderId = this.cellData.leaderId !== instructorId ? instructorId : '';
        for (const row of this.dataSource.rows) {
            if (row.rowType !== InstructorTableRowType.INSTRUCTOR) {
                continue;
            }
            const cell = row.cells.find(x => x.cellType === InstructorTableCellType.KID_SCHOOL
                && x.kidSchoolId === this.cellData.id);
            if (cell) {
                cell.isLeader = row.instructorId === this.cellData.leaderId;
            }
        }
        try {
            await this.updateDataSource();
        }
        catch (e) {
            console.error(e);
            Snackbar.error('Nepodařilo se změnit vedoucího!');
        }
        finally {
            this.togglingLeader = false;
        }
    }
    async isKidSchoolExisting() {
        try {
            await this.$store.dispatch('kidSchool/getById', this.cellData.id);
            return true;
        }
        catch {
            Snackbar.error('Školka již neexistuje!');
            await this.updateDataSource();
            return false;
        }
    }
    async addKidSchoolToCurrentUser() {
        if (!this.ensureContract()) {
            return;
        }
        this.loading = true;
        if (!await this.isKidSchoolExisting()) {
            this.loading = false;
            return;
        }
        const currentUserRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && x.isCurrentUserRow());
        if (currentUserRow === undefined) {
            this.loading = false;
            return;
        }
        const hours = Array(this.cellData.hourTo - this.cellData.hourFrom + (this.cellData.minuteTo === 0 ? 0 : 1))
            .fill(this.cellData.hourFrom).map((e, i) => e + i);
        for (const hour of hours) {
            const cellIndex = currentUserRow.cells.findIndex(x => x.hour === hour);
            if (cellIndex !== -1) {
                currentUserRow.cells.splice(cellIndex, 1);
            }
        }
        const instructorCell = new InstructorTableKidSchoolCell();
        instructorCell.hour = this.cellData.hourFrom;
        instructorCell.kidSchoolId = this.cellData.id;
        instructorCell.length = this.cellData.hourTo - this.cellData.hourFrom + (this.cellData.minuteTo === 0 ? 0 : 1);
        currentUserRow.cells.push(instructorCell);
        await this.updateDataSource();
        await this.syncInstructorAssignment(store.getters['user/userId'], true);
        this.loading = false;
    }
    async removeKidSchoolUser(callbackSearch, confirmTexts) {
        this.loading = true;
        if (!await this.isKidSchoolExisting()) {
            this.loading = false;
            return false;
        }
        const userRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && callbackSearch(x));
        if (userRow === undefined) {
            this.loading = false;
            return false;
        }
        const cellIndex = userRow.cells.findIndex(x => x.cellType === InstructorTableCellType.KID_SCHOOL
            && x.kidSchoolId === this.cellData.id);
        if (cellIndex === -1) {
            this.loading = false;
            return false;
        }
        if (!await ConfirmDialog.open(confirmTexts.title, confirmTexts.text, confirmTexts.confirm, confirmTexts.cancel)) {
            this.loading = false;
            return false;
        }
        userRow.cells.splice(cellIndex, 1);
        await this.updateDataSource();
        await this.syncInstructorAssignment(userRow.instructorId, false);
        this.loading = false;
        return true;
    }
    /**
     * The backoffice authorizes attendance by assignment, so a crew change is mirrored
     * there. The instructor is identified by e-mail, the only identity both systems share.
     */
    async syncInstructorAssignment(instructorId, assigned) {
        const email = this.$store.getters['instructor/get'](instructorId)?.data.email;
        if (!email) {
            return;
        }
        try {
            await this.$store.dispatch(assigned ? 'kidSchool/assignInstructor' : 'kidSchool/unassignInstructor', { id: this.cellData.id, email });
        }
        catch (e) {
            Snackbar.warning('Obsazení školky se nepodařilo přenést do rezervačního systému.');
        }
    }
    async removeKidSchoolToCurrentUser() {
        return this.removeKidSchoolUser((instructor) => instructor.isCurrentUserRow(), {
            title: 'Upozornění',
            text: 'Pokud se nemůžeš dostavit, neprodleně o tom informuj vedoucího školky!',
            confirm: 'Rozumím',
            cancel: 'Zrušit'
        });
    }
    async removeInstructorFromKidSchool(instructorId) {
        const result = await this.removeKidSchoolUser((instructor) => instructor.instructorId === instructorId, {
            title: 'Upozornění',
            text: 'Opravdu chcete odebrat instruktora?',
            confirm: 'Ano',
            cancel: 'Zrušit'
        });
        if (result) {
            await store.dispatch('notification/send', {
                instructor: instructorId,
                message: `Byl jste odebrán ze školky dne ${this.dataSource.date.format('D. M. YYYY')}
                    od ${this.cellData.hourFrom}:${this.cellData.minuteFrom}.`,
                type: NotificationTypes.WARNING,
                urgency: this.notificationUrgency,
                link: { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } }
            });
        }
        return result;
    }
    async removeKidSchool() {
        if (!await this.isKidSchoolExisting()) {
            return;
        }
        await ConfirmDialog.run(async () => {
            try {
                await this.$store.dispatch("kidSchool/destroy", this.cellData.id);
            }
            catch (e) {
                Snackbar.warning('Školka nemohla být smazána, jelikož jsou k ní přihlášeni klienti.');
                return;
            }
            for (const instructorId of this.cellData.instructorIds) {
                const userRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
                    && x.instructorId === instructorId);
                if (userRow === undefined) {
                    return;
                }
                const cellIndex = userRow.cells.findIndex(x => x.cellType === InstructorTableCellType.KID_SCHOOL
                    && x.kidSchoolId === this.cellData.id);
                if (cellIndex === -1) {
                    return;
                }
                userRow.cells.splice(cellIndex, 1);
                await store.dispatch('notification/send', {
                    instructor: instructorId,
                    message: `Školka dne ${this.dataSource.date.format('D. M. YYYY')}
                        od ${this.cellData.hourFrom}:${this.cellData.minuteFrom} byla zrušena`,
                    type: NotificationTypes.WARNING,
                    urgency: this.notificationUrgency,
                    link: { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } }
                });
            }
            await this.updateDataSource();
        }, 'Mazání školky', 'Opravdu si přejete smazat školku?');
    }
    async editKidSchool() {
        if (!await this.isKidSchoolExisting()) {
            return;
        }
        this.$emit('editKidSchool', this.cellData);
    }
    //</editor-fold>
    //<editor-fold desc="Getters">
    get isDesktop() {
        return isDesktop();
    }
    get canPayKids() {
        return this.isModerator() && !this.dataSource.concluded;
    }
    /** The lesson itself is a moderator's to change, and only while the day is open. */
    get canEditKidSchool() {
        return this.isModerator() && !this.dataSource.concluded;
    }
    /** Money is collected at the desk: the kid school leader or a moderator. */
    get canOpenPayments() {
        return this.isModerator() || this.cellData.leaderId === store.getters['user/userId'];
    }
    get attendanceRoute() {
        return { name: 'KidSchoolAttendance', params: { id: this.cellData.id } };
    }
    get paymentsRoute() {
        return { name: 'KidSchoolPayments', params: { id: this.cellData.id } };
    }
    get isRemoveButtonVisible() {
        const currentUserRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && x.isCurrentUserRow());
        if (currentUserRow === undefined) {
            return false;
        }
        const cellIndex = currentUserRow.cells.findIndex(x => x.cellType === InstructorTableCellType.KID_SCHOOL
            && x.kidSchoolId === this.cellData.id);
        if (cellIndex === -1) {
            return false;
        }
        return true;
    }
    get isAddButtonVisible() {
        if (this.isRemoveButtonVisible) {
            return false;
        }
        const currentUserRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && x.isCurrentUserRow());
        if (currentUserRow === undefined) {
            return false;
        }
        const hours = Array(this.cellData.hourTo - this.cellData.hourFrom + (this.cellData.minuteTo === 0 ? 0 : 1))
            .fill(this.cellData.hourFrom).map((e, i) => e + i);
        for (const cell of currentUserRow.cells.filter(x => x.cellType !== InstructorTableCellType.AVAILABLE && x.cellType !== InstructorTableCellType.PAUSE)) {
            for (let i = 0; i < cell.length; i++) {
                if (hours.some(x => x === i + cell.hour)) {
                    return false;
                }
            }
        }
        return true;
    }
    get timeString() {
        return `${this.cellData.hourFrom}:${this.cellData.minuteFrom === 0 ? '00' : this.cellData.minuteFrom}
        - ${this.cellData.hourTo}:${this.cellData.minuteTo === 0 ? '00' : this.cellData.minuteTo}`;
    }
    isModerator() {
        return this.$store.getters['user/isModerator'];
    }
};
__decorate([
    Prop({ required: true })
], InstructorsTableKidSchoolCell.prototype, "cellData", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableKidSchoolCell.prototype, "dataSource", void 0);
InstructorsTableKidSchoolCell = __decorate([
    Component
], InstructorsTableKidSchoolCell);
export default InstructorsTableKidSchoolCell;
